import React__default from 'react';
import classnames from 'classnames';

const SelectWrapper = ({ children , className ,  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classnames('select-wrapper', className)
    }, children)
;

export { SelectWrapper };
//# sourceMappingURL=SelectWrapper.js.map
